import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { withStyles } from '@material-ui/core/styles'
import store from '../../store'
import {
  removeExpense,
  editExpense,
  // selectExpenseId,
  loadExpenseItems
} from '../../actions/index'
import FontAwesome from 'react-fontawesome'
import Checkbox from '@material-ui/core/Checkbox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import mobileView from '../../utils/mobile.utils'
import { useTranslation } from 'react-i18next'

const styles = (theme) => ({
  tablecell: {
    fontSize: '12px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      padding: 4
    }
  },
  tableRowHover: {
    position: 'relative',
    boxSizing: 'border-box',
    '&:hover': {
      border: '3px solid #44c0cc'
    }
  }
})

const ExpenseRow = (props) => {
  const {
    classes,
    index,
    invoice_expense_id,
    invoice_id,
    added_to_invoice,
    isSelected,
    company_name,
    date_of_purchase,
    place_of_purchase,
    sum,
    handleViewExpense,
    handleEditExpense,
    handleSelect
  } = props

  const {t} = useTranslation()

  return added_to_invoice ? (
    <TableRow
      hover
      role="checkbox"
      tabIndex={-1}
      key={invoice_expense_id}
      style={index % 2 ? { background: 'white' } : { background: '#ebf9fa' }}
      onClick={(e) => {
        if (e.target.closest('input[type="checkbox"]')) {
          // handleSelect(isSelected, id)
          return
        } else {
          handleViewExpense(index, invoice_expense_id, false, false)
        }
      }}
      className={classes.tableRowHover}
    >
      <TableCell
        padding="checkbox"
        className={mobileView ? classes.tablecell : null}
      >
        {added_to_invoice ? (
          <Checkbox
            icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
            checkedIcon={
              <CheckBoxIcon fontSize="large" style={{ fill: '#F67131' }} />
            }
            checked={isSelected}
            disabled={true}
          />
        ) : (
          <Checkbox
            icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
            checkedIcon={
              <CheckBoxIcon fontSize="large" style={{ fill: '#F67131' }} />
            }
            checked={isSelected}
            disabled={false}
          />
        )}
      </TableCell>
      <TableCell
        component="th"
        scope="row"
        className={classNames(classes.tablecell, 'hide-mobile')}
      >
        {company_name}
      </TableCell>
      <TableCell component="th" scope="row" className={classes.tablecell}>
        {invoice_id}
      </TableCell>
      <TableCell
        component="th"
        scope="row"
        className={classNames(classes.tablecell, 'hide-mobile')}
      >
        {date_of_purchase}
      </TableCell>
      <TableCell
        component="th"
        scope="row"
        className={classNames(classes.tablecell, 'hide-mobile')}
      >
        {place_of_purchase}
      </TableCell>
      <TableCell component="th" scope="row" className={classes.tablecell}>
        {sum}
      </TableCell>

      <TableCell component="th" scope="row" className={classes.tablecell}>
        <div style={{ display: 'flex' }}>
          {added_to_invoice ? (
            <p
              style={{
                marginLeft: '10px',
                color: 'Gray',
                paddingRight: '15px'
              }}
            >
              <FontAwesome name="pencil" className="fa-disable" />
            </p>
          ) : (
            <div
              className="link action-icon"
              style={{ paddingRight: '15px' }}
              onClick={(e) => {
                e.stopPropagation()
                store.dispatch(editExpense(index, invoice_expense_id))
                store.dispatch(loadExpenseItems())
                handleEditExpense()
              }}
            >
              <p style={{ marginLeft: '10px' }}>
                <FontAwesome name="pencil" />
              </p>
            </div>
          )}

          {added_to_invoice ? (
            <p
              style={{
                marginLeft: '10px',
                paddingRight: '15px',
                color: 'Gray'
              }}
            >
              <FontAwesome name="window-close" className="fa-disable" />
            </p>
          ) : (
            <p
              style={{ marginLeft: '10px', marginRight: '15px' }}
              className="link"
              onClick={(e) => {
                e.stopPropagation()
                store.dispatch(removeExpense(index, invoice_expense_id))
                // if (isSelected) {
                // handleViewExpense(index, invoice_expense_id)
                // }
              }}
            >
              <FontAwesome
                name="window-close"
                style={{
                  color: 'red'
                }}
              />
            </p>
          )}
        </div>
      </TableCell>
    </TableRow>
  ) : (
    <TableRow
      hover
      className={classes.tableRowHover}
      role="checkbox"
      onClick={(e) => {
        if (e.target.closest('input[type="checkbox"]')) {
          handleSelect(isSelected, invoice_expense_id)
          return
        } else {
          handleViewExpense(index, invoice_expense_id, added_to_invoice, false)
        }
      }}
      tabIndex={-1}
      key={invoice_expense_id}
      style={index % 2 ? { background: 'white' } : { background: '#ebf9fa' }}
    >
      <TableCell
        padding="checkbox"
        className={mobileView ? classes.tablecell : null}
      >
        {added_to_invoice ? (
          <Checkbox
            icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
            checkedIcon={
              <CheckBoxIcon fontSize="large" style={{ fill: '#F67131' }} />
            }
            checked={isSelected}
            disabled={true}
          />
        ) : (
          <Checkbox
            icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
            checkedIcon={
              <CheckBoxIcon fontSize="large" style={{ fill: '#F67131' }} />
            }
            checked={isSelected}
            disabled={false}
          />
        )}
      </TableCell>
      <TableCell
        component="th"
        scope="row"
        className={classNames(classes.tablecell, 'hide-mobile')}
      >
        {company_name === 'Tyhjä' ? t('expences.company_name') : company_name}
      </TableCell>
      <TableCell component="th" scope="row" className={classes.tablecell}>
        {invoice_id}
      </TableCell>
      <TableCell
        component="th"
        scope="row"
        className={classNames(classes.tablecell, 'hide-mobile')}
      >
        {date_of_purchase}
      </TableCell>
      <TableCell
        component="th"
        scope="row"
        className={classNames(classes.tablecell, 'hide-mobile')}
      >
        {place_of_purchase}
      </TableCell>
      <TableCell component="th" scope="row" className={classes.tablecell}>
        {sum}
      </TableCell>

      <TableCell component="th" scope="row" className={classes.tablecell}>
        <div style={{ display: 'flex' }}>
          {added_to_invoice ? (
            <p
              style={{
                marginLeft: '10px',
                color: 'Gray',
                paddingRight: '15px'
              }}
            >
              <FontAwesome name="pencil" className="fa-disable" />
            </p>
          ) : (
            <div
              className="link action-icon"
              style={{ paddingRight: '15px' }}
              onClick={(e) => {
                e.stopPropagation()
                store.dispatch(editExpense(index, invoice_expense_id))
                store.dispatch(loadExpenseItems())
                handleEditExpense()
              }}
            >
              <p style={{ marginLeft: '10px' }}>
                <FontAwesome name="pencil" />
              </p>
            </div>
          )}

          {added_to_invoice ? (
            <p
              style={{
                marginLeft: '10px',
                paddingRight: '15px',
                color: 'Blue'
              }}
            >
              <FontAwesome name="window-close" className="fa-disable" />
            </p>
          ) : (
            <p
              style={{ marginLeft: '10px', marginRight: '15px' }}
              className="link"
              onClick={(e) => {
                e.stopPropagation()
                store.dispatch(removeExpense(index, invoice_expense_id))
                // if (isSelected) {
                //  handleClick()
                // }
              }}
            >
              <FontAwesome
                name="window-close"
                style={{
                  color: '#F67131'
                }}
              />
            </p>
          )}
        </div>
      </TableCell>
    </TableRow>
  )
}

ExpenseRow.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ExpenseRow)
